import Image from 'next/image'
import styles from './banner.module.css'

export default function Banner({ data }) {
  return (
    <>
      <div className={`${styles.bg}`}>
        <Image
          src={data.imagem.url}
          alt="Detalhe imóvel"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
        />
        <div className={styles.content}>
          <div className={styles.title}>
            <div className={styles.parallelogramSpan} style={{ background: '#d72e3f' }}>
              <span>{data.titulo}</span>
            </div>
          </div>
          <div className={styles.chamada}>
            <span>{data.chamada}</span>
          </div>
        </div>
      </div>
    </>
  )
}